import { render, staticRenderFns } from "./StartupSearchHelp.vue?vue&type=template&id=360ac836&scoped=true"
import script from "./StartupSearchHelp.vue?vue&type=script&lang=js"
export * from "./StartupSearchHelp.vue?vue&type=script&lang=js"
import style0 from "./StartupSearchHelp.vue?vue&type=style&index=0&id=360ac836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ac836",
  null
  
)

export default component.exports